{
  "branding": {
    "frontdesk-attribution": "Susținut de FrontDesk+",
    "practice-logo": "Sigla {{name}}"
  },
  "validation": {
    "required": "Acest câmp este obligatoriu",
    "invalid-url": "Vă rugăm introduceți un URL valid",
    "pin-too-short": "PIN-ul trebuie să aibă cel puțin 4 caractere",
    "pin-default-rejected": "Codul PIN standard 0000 nu este permis. Vă rugăm să atribuiți propriul PIN.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Înapoi",
    "next": "Următorul",
    "cancel": "Anulare",
    "confirm": "Confirmă",
    "done": "Gata",
    "retry": "Reîncercare",
    "clear": "Șterge",
    "close": "Închide",
    "verifying": "Verificare...",
    "select": "Selectează",
    "minutes": "minute",
    "clock": "",
    "gender": {
      "M": "Masculin",
      "W": "Feminin",
      "D": "Diverse",
      "U": "Necunoscut"
    },
    "insurance": {
      "GKV": "De stat",
      "PKV": "Private",
      "SELFPAY": "Autofinanțare"
    },
    "scroll-up": "Derulați în sus",
    "scroll-down": "Derulați în jos"
  },
  "settings": {
    "device-reset": {
      "title": "Resetează dispozitivul",
      "description": "Șterge conexiunea cu cabinetul, setările și codul PIN de pe acest dispozitiv.",
      "confirmation": "Dispozitivul va trebui configurat din nou. Configurația SOL și datele pacienților din inSuite rămân neschimbate.",
      "cancel": "Anulează",
      "confirm": "Resetează acum"
    },
    "title": "Setări",
    "save": "Salvează",
    "save-success": "Setări salvate",
    "save-error": "Salvarea setărilor a eșuat",
    "load-error": "Încărcarea setărilor a eșuat",
    "pin": {
      "title": "PIN Necesar",
      "description": "Vă rugăm introduceți PIN-ul pentru a accesa setările.",
      "error": "PIN greșit. Vă rugăm încercați din nou.",
      "backspace": "Ștergeți ultima cifră"
    },
    "connection": {
      "title": "Conexiune",
      "description": "Setări de conexiune pentru serverul Doc-Cirrus Bridge",
      "bridge-url": "URL Bridge",
      "device-name": "Nume dispozitiv",
      "device-name-placeholder": "de ex. Recepție, Sala 1, Chioșc",
      "device-name-hint": "Nume pentru identificare în tabloul de bord Bridge",
      "kim-address": "Adresa KIM (opțional)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Test",
      "success": "Conexiune reușită",
      "error": "Conexiune eșuată",
      "api-unreachable": "API-ul DocCirrus inaccesibil",
      "status-title": "Starea conexiunii",
      "status": {
        "api": "API conectat",
        "ti": "Infrastructura telematică",
        "card-reader": "Cititor de carduri disponibil",
        "medical-card": "Cardul cabinetului medical (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Token Sol (din inSuite)",
      "sol-token-hint": "Copiați-l din administrarea Bridge din inSuite. Necesar pentru conexiune.",
      "sol-token-show": "Afișează tokenul",
      "sol-token-hide": "Ascunde tokenul",
      "bridge-unreachable": "Bridge nu poate fi accesat. Verificați adresa și portul.",
      "diagnostic-id": "ID diagnostic: {{id}}",
      "scan-qr": "Scanați codul QR",
      "scan-title": "Scanați codul QR Bridge",
      "scan-manual": "Introduceți manual"
    },
    "terminal": {
      "title": "Cititor de carduri",
      "description": "Selectarea cititorului de carduri pentru infrastructura telematică",
      "select": "Selectează Terminal",
      "select-placeholder": "Alege terminal...",
      "loading": "Se încarcă terminalele...",
      "none-available": "Niciun terminal disponibil",
      "none-found": "Niciun terminal găsit",
      "found": "{{count}} terminal(e) găsit(e)",
      "connect-hint": "Conectați-vă mai întâi la serverul bridge pentru a încărca terminalele.",
      "found-count": "Cititoare de carduri găsite: {{count}}",
      "refresh": "Reîncărcați cititoarele de carduri"
    },
    "practice": {
      "title": "Cabinet medical",
      "description": "Informații despre cabinetul medical",
      "name": "Numele cabinetului medical",
      "name-placeholder": "ex. Dr. Ion Popescu",
      "welcome-message": "Mesaj de Bun Venit",
      "welcome-placeholder": "de ex. Bine ați venit la cabinetul nostru medical",
      "scheduler-available": "Activați Scheduler",
      "scheduler-available-description": "Permiteți pacienților să facă rezervări prin intermediul terminalului cu autoservire",
      "prescription-available": "Activați serviciul de prescripție",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Lăsați gol pentru a saluta pacienții în limba lor. Textul propriu este afișat neschimbat în toate limbile."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Salvat pentru toate dispozitivele la {{value}}",
      "never-saved-default": "Setare implicită, încă nemodificată."
    },
    "anamnesis": {
      "title": "Istoric medical digital",
      "description": "Afișează un link și QR code către furnizorul dumneavoastră de istoric medical după check-in.",
      "enabled": "Afișați linkul istoric medical după check-in",
      "enabled-description": "Afișează un link și QR code către furnizorul dumneavoastră de istoric medical după o înregistrare finalizată, de exemplu Nelly.",
      "url": "Link furnizor de istoric medical",
      "url-hint": "Legătura este statică și identică pentru toți pacienții.",
      "preview-label": "Previzualizare ecran de finalizare",
      "preview-note": "Legătura este statică și identică pentru toți pacienții.",
      "url-first": "Introduceți mai întâi un link valid pentru a activa."
    },
    "appearance": {
      "title": "Aspect",
      "description": "Personalizați interfața utilizatorului",
      "language": "Limbă",
      "default-kiosk-language": "Limba implicită a pacientului",
      "default-kiosk-language-hint": "Limba în care încep noile sesiuni de chioșc pentru pacienți.",
      "voice-over-volume": "Volum voce off",
      "voice-over-hint": "Controlează volumul asistentului vocal pentru accesibilitate.",
      "language-first": "Afișează selectarea limbii la începutul sesiunii"
    },
    "security": {
      "title": "Securitate",
      "description": "PIN pentru accesarea setărilor",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Administrarea chioșcului",
    "nav": {
      "general": "General",
      "flows": "Funcții",
      "anamnese": "Anamneză digitală",
      "device": "Dispozitiv și conexiune"
    },
    "flows": {
      "title": "Funcții pe terminal"
    },
    "language": {
      "title": "Limbă și redare vocală",
      "description": "Limba și citirea cu voce tare pentru pacienți pe acest dispozitiv."
    }
  },
  "self-service": {
    "title": "Self-Service",
    "step-progress": "Pasul {{current}} / {{total}}",
    "flows": {
      "checkin": "Check-in",
      "scheduler": "Programează Consultație",
      "prescription": "Prescriptii",
      "locations": "Hartă Locație",
      "emergency": "Urgență"
    },
    "audio-guide": {
      "on": "Sunet pornit",
      "off": "Sunet oprit",
      "replay": "Repetă instrucțiunile",
      "replay-unavailable": "Nu există instrucțiuni vocale de repetat"
    },
    "language-selector": {
      "title": "Selectați limba",
      "description": "Vă rugăm să selectați limba preferată"
    },
    "settings": "Setări",
    "start": {
      "welcome": "Bun venit",
      "subtitle": "Vă rugăm selectați o opțiune",
      "check-in-label": "Calea principală",
      "check-in-cta": "Check-in",
      "check-in-description": "Aveți deja o programare? Faceți check-in aici.",
      "check-in-hint": "Pregătiți cardul",
      "scheduler-label": "Nou",
      "scheduler-cta": "Programează Consultație",
      "scheduler-description": "Programați o nouă consultație.",
      "location-plan": "Hartă Locație",
      "location-plan-description": "Găsiți drumul către sala de tratament.",
      "prescription-label": "Prescriptie",
      "prescription-cta": "Prescripții și Comandă",
      "prescription-description": "Vizualizați rețetele sau comandați rezerve.",
      "emergency-cta": "Alertă locală de urgență",
      "emergency-description": "Se aude doar pe acest dispozitiv și nu cheamă ajutor.",
      "tap-to-start": "Atingeți pentru a începe"
    },
    "offline": {
      "banner-title": "Înregistrarea temporară indisponibilă",
      "banner-message": "Vă rugăm să vorbiți cu personalul de la recepție pentru asistență.",
      "emergency-available": "Alerta locală rămâne disponibilă. Nu cheamă ajutor.",
      "flow-disabled": "Indisponibil temporar"
    },
    "readability": {
      "toggle-label": "Mod citire",
      "on": "Mod citire",
      "off": "Mod citire"
    },
    "reset-overlay": {
      "timeout-title": "Sesiune încheiată",
      "timeout-subtitle": "Timpul dvs. a expirat. Datele dvs. sunt în siguranță.",
      "offline-title": "Conexiune pierdută",
      "offline-subtitle": "Conexiunea a fost întreruptă. Vă rugăm să vorbiți cu personalul de la recepție.",
      "interruption-title": "Sesiunea sa încheiat",
      "interruption-subtitle": "Sesiunea dvs. a fost încheiată în siguranță.",
      "completion-title": "Mulțumesc!",
      "completion-subtitle": "Solicitarea dvs. a fost finalizată cu succes.",
      "reassurance": "Datele dumneavoastră personale nu sunt stocate pe acest dispozitiv.",
      "auto-dismiss": "Revenirea la pornire în {{seconds}} secunde...",
      "dismiss": "Treceți la început"
    },
    "timed-terminal": {
      "countdown": "Revenire automată în {{seconds}} secunde",
      "countdown-outcome": "Acest terminal va reveni automat la ecranul de pornire.",
      "more-time": "Mai mult timp",
      "extended": "Timp prelungit"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Aceste întrebări nu sunt disponibile în limba dumneavoastră. Alegeți una dintre limbile oferite sau contactați recepția.",
        "alternatives": "Programări alternative",
        "loading": "Se încarcă întrebările…",
        "reception-fallback": "Vă rugăm să vă adresați recepției.",
        "error-title": "Întrebările nu au putut fi încărcate",
        "language-unavailable-lead": "Aceste întrebări nu sunt disponibile în limba dvs.",
        "language-unavailable-title": "Vă rugăm să alegeți una dintre aceste limbi",
        "language-unavailable-body": "Sau cereți ajutor la recepție."
      },
      "start": {
        "title": "Programează Consultație",
        "subtitle": "Programați consultația preferată în câțiva pași",
        "welcome": "Bun venit la Programarea Consultațiilor",
        "description": "Vă vom ghida prin procesul de programare",
        "cta": "Programează consultație acum"
      },
      "patient-id": {
        "title": "Identificare",
        "subtitle": "Vă rugăm identificați-vă",
        "mode-card": "Cu card",
        "mode-search": "Căutare",
        "mode-create": "Creează nou",
        "insert-card": "Vă rugăm introduceți cardul de asigurare",
        "reading-card": "Se citește cardul...",
        "simulate-card": "Simulează card",
        "multiple-matches": "Găsiți mai mulți pacienți. Se folosesc datele de pe card.",
        "search-placeholder": "Nume sau număr de asigurare...",
        "searching": "Se caută...",
        "no-results": "Niciun rezultat găsit",
        "first-name": "Prenume",
        "last-name": "Nume",
        "dob": "Data nașterii",
        "insurance": "Asigurare",
        "continue": "Continuă",
        "creating": "Se creează pacient...",
        "patient-created": "Pacient creat cu succes!",
        "create-error": "Nu s-a putut crea pacientul."
      },
      "appointment-type": {
        "title": "Selectați Tipul de Consultație",
        "subtitle": "Vă rugăm selectați motivul vizitei",
        "loading": "Se încarcă tipurile de consultații...",
        "no-types": "Niciun tip de consultație disponibil",
        "error": "Nu s-au putut încărca tipurile de consultații. Vă rugăm încercați din nou.",
        "no-bookable": "Aceste tipuri de programări nu pot fi rezervate momentan la chioșc. Vă rugăm să vă adresați recepției sau să programați telefonic.",
        "disabled-default": "Vă rugăm să programați această vizită direct la recepție sau telefonic.",
        "disabled-footer": "Doar recepție/telefon",
        "lead": "Ce tip de programare doriți?",
        "duration": "aprox. {{minutes}} minute",
        "empty-title": "Momentan nu se pot face programări aici",
        "none-bookable-title": "Aceste programări nu se pot face aici",
        "none-bookable-body": "Vă rugăm să întrebați la recepție sau să ne sunați."
      },
      "types": {
        "general": "Consultație Generală",
        "general-desc": "Pentru plângeri și întrebări generale",
        "checkup": "Control Preventiv",
        "checkup-desc": "Controale de sănătate regulate",
        "vaccination": "Vaccinare",
        "vaccination-desc": "Programați o vaccinare",
        "followup": "Urmărire",
        "followup-desc": "Consultație de control",
        "prescription": "Rețetă",
        "prescription-desc": "Ridicare rețetă"
      },
      "slot-selection": {
        "title": "Selectați Consultația",
        "subtitle": "Vă rugăm selectați o consultație disponibilă",
        "loading": "Se încarcă consultațiile disponibile...",
        "no-slots": "Nicio consultație disponibilă",
        "no-appointment-type": "Niciun tip de consultație selectat",
        "error": "Nu s-au putut încărca intervalele disponibile. Vă rugăm încercați din nou.",
        "quick-select": "Următoarele consultații disponibile:",
        "select-date": "Sau selectați o dată:",
        "times-for": "{{date}}",
        "available": "Disponibil",
        "unavailable": "Fără intervale",
        "slots": "intervale",
        "select-time-hint": "Atingeți o oră pentru a vă programa consultația",
        "week-short": "Săpt",
        "weekday-mon": "Lun",
        "weekday-tue": "Mar",
        "weekday-wed": "Mie",
        "weekday-thu": "Joi",
        "weekday-fri": "Vin",
        "weekday-sat": "Sâm",
        "weekday-sun": "Dum",
        "period-morning": "Dimineață",
        "period-midday": "Amiază",
        "period-afternoon": "După-amiază",
        "period-evening": "Seară",
        "period-morning-short": "Dim.",
        "period-midday-short": "Amiază",
        "period-afternoon-short": "P.A.",
        "period-evening-short": "Seară",
        "period-dots-legend": "Disponibilitate oră",
        "filter-hint": "Filtrați după orele preferate:",
        "or-choose-below": "sau alegeți mai jos",
        "no-slots-period": "Fără sloturi",
        "show-all": "Afișează tot",
        "free": "gratuit",
        "your-selection": "Selecția dvs",
        "oclock": "ora",
        "choose-slot": "Alegeți slotul",
        "choose-day": "Alegeți ziua",
        "choose-day-first": "Vă rugăm să alegeți mai întâi o zi",
        "times-heading": "Ore libere pe {{date}}",
        "time-value": "{{time}}",
        "empty-title": "Nicio programare liberă în {{month}}",
        "empty-body": "Uitați-vă în luna următoare sau întrebați la recepție – vă ajutăm cu plăcere.",
        "next-month": "Luna următoare",
        "previous-month": "Luna anterioară"
      },
      "confirmation": {
        "patient-responses": "Răspunsurile dumneavoastră",
        "review-loading": "Se verifică rezumatul…",
        "review-unavailable": "Rezumatul nu este disponibil. Vă rugăm să încercați din nou sau să întrebați la recepție.",
        "check-booking": "Verifică programarea",
        "title": "Confirmați Consultația",
        "subtitle": "Vă rugăm verificați programarea",
        "patient": "Pacient",
        "datetime": "Data și ora",
        "booking": "Se programează...",
        "confirm": "Programează consultație",
        "heading": "Arată corect?",
        "lead": "Vă rugăm să confirmați programarea.",
        "appointment": "Numire",
        "insured-via": "Asigurat prin",
        "description-label": "Observații pentru cabinet (opțional)",
        "description-hint": "Spuneți-ne dacă trebuie să ținem cont de ceva la programare sau la check-in.",
        "description-placeholder": "de ex. mobilitate redusă, însoțitor, observații importante",
        "description-too-long": "Vă rugăm să limitați observația la cel mult 500 de caractere.",
        "summary": "Rezumat",
        "change": "Schimbare",
        "book-binding": "Fă programare",
        "cancel": "Anulare",
        "type-label": "Tipul programării",
        "datetime-value": "{{date}} la {{time}}",
        "name-label": "Nume",
        "insurance-label": "Asigurare",
        "insurance-GKV": "Asigurare de sănătate publică",
        "insurance-PKV": "Asigurare de sănătate privată",
        "insurance-SELFPAY": "Plată proprie",
        "change-time": "Modificați programarea",
        "description-free-text": "Alte mențiuni (opțional)",
        "note-wheelchair": "Folosesc un scaun cu rotile",
        "note-companion": "Vin însoțit/ă",
        "note-interpreter": "Am nevoie de un interpret"
      },
      "done": {
        "title": "Consultație Programată!",
        "label": "Rezervat",
        "subtitle": "Consultația dvs. a fost programată cu succes.",
        "date": "Data",
        "time": "Ora",
        "booking-id": "Număr programare",
        "qr-hint": "Adăugați la calendar",
        "qr-description": "Scanați acest cod QR cu camera smartphone-ului pentru a adăuga consultația la aplicația de calendar",
        "auto-redirect": "Veți fi redirecționat către pagina de start în curând...",
        "auto-redirect-countdown": "Revenire la start în {{seconds}} secunde...",
        "back-to-start": "Înapoi la start",
        "print-button": "Tipărește biletul de programare",
        "print-preparing": "Se pregătește vizualizarea pentru tipărire…",
        "print-error": "Biletul de programare nu a putut fi deschis. Încercați din nou sau cereți ajutor la recepție.",
        "print-returned": "Vizualizarea de tipărire a sistemului a fost închisă. Puteți solicita un alt exemplar dacă este necesar.",
        "print-title": "Programarea dumneavoastră",
        "print-location": "Locație",
        "print-map-hint": "Deschideți locația pe telefon",
        "print-error-v2": "Bonul programării nu a putut fi deschis. Vă rugăm să încercați din nou sau să întrebați la recepție."
      },
      "error": {
        "assistance-info": "Nu am putut confirma programarea. Este posibil ca programarea să fie deja făcută. Vă rugăm să întrebați la recepție.",
        "pending-title": "Programare neconfirmată",
        "pending-info": "Nu am putut confirma programarea. Este posibil ca programarea să fie deja făcută. Vă rugăm să verificați din nou sau să întrebați la recepție.",
        "title": "Programare Eșuată",
        "subtitle": "Consultația nu a putut fi programată.",
        "info": "Vă rugăm să încercați din nou sau să întrebați la recepție."
      },
      "phase": {
        "identify": "Înregistrare",
        "choose": "Alegerea orei",
        "confirm": "Confirmare"
      }
    },
    "prescription": {
      "start": {
        "title": "Prescripții și comenzi",
        "subtitle": "Introduceți cardul de asigurare pentru a vedea rețetele sau pentru a comanda rezerve.",
        "button": "Introduceți card"
      },
      "card-check": {
        "loading": "Se încarcă cititorul de carduri...",
        "no-terminal": "Niciun cititor de carduri configurat",
        "no-terminal-hint": "Vă rugăm să contactați personalul pentru asistență.",
        "insert-card": "Introduceți cardul",
        "insert-card-hint": "Introduceți cardul de asigurare în cititorul de carduri.",
        "card-detected": "Card detectat",
        "reading": "Cartela de citire...",
        "reading-hint": "Vă rugăm să așteptați un moment.",
        "error": "Eroare la citirea cardului",
        "retry": "Încercați din nou",
        "manual-lookup": "Continuați fără card",
        "load-error": "Nu s-a putut încărca cititorul de carduri",
        "read-error": "Cardul nu a putut fi citit"
      },
      "patient-selection": {
        "title": "Selectați Pacient",
        "subtitle": "Au fost depistaţi mai mulţi pacienţi. Vă rugăm să vă selectați numele.",
        "try-again": "Încercați din nou",
        "try-again-hint": "Introduceți cardul din nou"
      },
      "list": {
        "title": "Reţetele dumneavoastră",
        "for-patient": "Prescripții pentru {{name}}",
        "loading": "Se încarcă prescripțiile...",
        "error-title": "Eroare de încărcare",
        "fetch-error": "Rețetele nu au putut fi încărcate",
        "back-home": "Înapoi la Start",
        "done": "Efectuat"
      },
      "detail": {
        "prescription-info": "Informații de prescripție",
        "date": "Data",
        "prescriber": "Prescriptor",
        "comment": "Notă",
        "medications": "Medicamente",
        "form": "Formular",
        "pack-size": "Dimensiunea pachetului",
        "manufacturer": "Producator",
        "loading": "Se încarcă prescripția...",
        "fetch-error": "Detaliile prescripției nu au putut fi încărcate",
        "back-to-list": "Înapoi la listă",
        "print": "Print"
      },
      "types": {
        "public": "Prescriptie publica",
        "private": "Reţetă privată",
        "long-term": "Reţetă pe termen lung",
        "btm": "Reţetă de narcotice",
        "g": "Green Prescription",
        "t": "T-Prescriptie"
      },
      "no-patient": {
        "title": "Pacientul nu a fost găsit",
        "subtitle": "Din păcate, nu a fost găsit niciun pacient pentru acest card. Vă rugăm să contactați personalul pentru asistență.",
        "try-again": "Încercați din nou",
        "back-home": "Înapoi la Start",
        "title-v2": "Nu s-au găsit date potrivite",
        "subtitle-v2": "Nu v-am putut găsi. Vă rugăm să încercați din nou sau să întrebați la recepție."
      },
      "done": {
        "title": "Mulțumesc",
        "subtitle": "Puteți lua loc acum. Dacă aveți întrebări, vă rugăm să contactați personalul.",
        "no-prescriptions-title": "Fără prescripții la dosar",
        "no-prescriptions-subtitle": "Nu am putut găsi rețete active pentru dvs. Dacă vă așteptați la unul, vă rugăm să contactați personalul recepției.",
        "error-title": "A apărut o eroare",
        "error-subtitle": "Vă rugăm să contactați personalul pentru asistență suplimentară.",
        "auto-redirect": "Redirecționare automată în {{seconds}} secunde",
        "finish": "Înapoi la Start"
      },
      "hub": {
        "title": "Reţetele dumneavoastră",
        "for-patient": "Prescripții pentru {{name}}",
        "loading": "Se încarcă prescripțiile...",
        "error-title": "Eroare de încărcare",
        "fetch-error": "Nu s-au putut încărca rețetele",
        "back-home": "Înapoi la Start",
        "done": "Efectuat",
        "order-button": "Prescrierea Ordinului",
        "existing-prescriptions": "Reţetele dumneavoastră curente",
        "no-prescriptions": "Nu s-au găsit rețete active."
      },
      "patient-lookup": {
        "title": "Găsiți pacient",
        "subtitle": "Introduceți numele și data nașterii.",
        "last-name": "Nume",
        "first-name": "Prenume",
        "date-of-birth": "Data naşterii",
        "lastname": "Nume",
        "lastname-placeholder": "Numele dvs. de familie",
        "firstname": "Prenume",
        "firstname-placeholder": "Prenume",
        "dob": "Data naşterii",
        "search": "Căutare",
        "searching": "Se caută...",
        "search-error": "Eroare de căutare: {{message}}",
        "no-match": "Nu a fost găsit niciun pacient. Vă rugăm să vă verificați informațiile.",
        "error": "Eroare de căutare. Vă rugăm să încercați din nou.",
        "found": "Pacient găsit",
        "confirm": "Confirmați",
        "ambiguous": "Potriviri multiple",
        "ambiguous-hint-firstname": "Vă rugăm să introduceți și prenumele pentru a rafina căutarea.",
        "ambiguous-hint-additional": "Vă rugăm să vă verificați informațiile sau să contactați personalul.",
        "not-found": "Pacientul nu a fost găsit",
        "not-found-hint": "Niciun pacient nu a putut fi găsit cu aceste detalii.",
        "not-found-action": "Încercați din nou"
      },
      "manual-identification": {
        "unverified": "Identitatea dumneavoastră nu a fost confirmată cu cardul de sănătate. Cabinetul va verifica datele și solicitarea înainte de procesare."
      },
      "medication-selection": {
        "title": "Solicitați o rețetă",
        "subtitle": "Cabinetul medical analizează cererea dumneavoastră. După aprobare, eRx este gata în aplicația dumneavoastră e-prescription.",
        "back": "Înapoi",
        "submit": "Continuați revizuirea",
        "reason-title": "De ce ai nevoie de rețetă?",
        "reason-hint": "Ajută cabinetul medical să evalueze cererea dumneavoastră.",
        "reason-validation": "Vă rugăm să alegeți un motiv.",
        "reason-schmerzen": "Durere",
        "reason-entzuendung": "Inflamatie",
        "reason-nachsorge": "După operație procedura /",
        "reason-allergie": "Reacție alergică /",
        "reason-chronisch": "Afecţiune cronică",
        "reason-anderes": "Altceva",
        "medications-title": "Ce medicamente?",
        "request-hint": "Descrieți de ce aveți nevoie sau denumiți rețeta anterioară pe care doriți să o reînnoiți.",
        "request-placeholder": "de ex. Ibuprofen 600 mg, la fel ca data trecută",
        "request-validation": "Vă rugăm să descrieți ce medicamente aveți nevoie.",
        "history-title": "Prescriptii anterioare",
        "history-hint": "Adăugați o intrare pentru a vă completa solicitarea.",
        "history-loading": "Se încarcă prescripțiile anterioare...",
        "history-error": "Rețetele anterioare nu au putut fi încărcate.",
        "history-add": "Adaugă",
        "history-added": "Adăugat",
        "history-date": "Ultimul: {{date}}",
        "history-request-line": "Reînnoire: {{medicationName}}",
        "urgency-title": "Cât de urgent este?",
        "urgency-hint": "Ajută cabinetul medical să stabilească prioritatea.",
        "urgency-soon": "Urgent",
        "urgency-soon-meta": "In cel mai scurt timp posibil",
        "urgency-tomorrow": "În curând",
        "urgency-tomorrow-meta": "În următoarele câteva zile",
        "urgency-week": "Săptămâna aceasta",
        "urgency-week-meta": "Fără presiune de timp",
        "lead": "Cabinetul vă verifică cererea. După aprobare, găsiți rețeta electronică în aplicația pentru rețete electronice sau pe cardul de sănătate.",
        "history-hint-v2": "Atingeți o rețetă anterioară pentru a o prelua.",
        "history-retry": "Reîncărcare"
      },
      "request-review": {
        "title": "Ordin de revizuire",
        "subtitle": "Vă rugăm să revizuiți cererea de prescripție medicală.",
        "request-label": "Medicația solicitată",
        "selected-medications": "Medicamente selectate",
        "free-text-medications": "Medicamente suplimentare",
        "freetext-label": "Altele",
        "quarterly-warning": "Cardul dumneavoastră de asigurare nu a fost citit în acest trimestru. Cabinetul medical vă poate contacta.",
        "egk-warning": "Cardul dumneavoastră de asigurare nu a fost citit în acest trimestru. Cabinetul medical vă poate contacta.",
        "submit": "Trimiteți",
        "submitting": "Se trimite...",
        "submit-error": "Nu s-a putut depune cererea. Vă rugăm să încercați din nou.",
        "back": "Înapoi",
        "reason-label": "Motivul",
        "urgency-label": "Urgenţă",
        "completion-email-choice": "Doresc să primesc un e-mail când cabinetul îmi procesează solicitarea.",
        "completion-email-label": "Adresă de e-mail",
        "completion-email-placeholder": "nume@exemplu.ro",
        "completion-email-hint": "Doar pentru acest mesaj unic. Adresa nu este salvată în datele de bază.",
        "completion-email-invalid": "Introduceți o adresă de e-mail validă.",
        "egk-proof-required": "Cererile de rețetă sunt disponibile numai după citirea cu succes a cardului de asigurare. Vă rugăm să contactați personalul.",
        "title-v2": "Verificați cererea",
        "completion-email-hint-v2": "Adresa este folosită doar pentru acest mesaj."
      },
      "confirmation": {
        "title": "Solicitare trimisă",
        "subtitle": "Solicitarea dumneavoastră de prescripție a fost trimisă cu succes.",
        "success-title": "Solicitare trimisă",
        "success-subtitle": "Solicitarea dumneavoastră de prescripție a fost trimisă cu succes.",
        "estimated-time": "Rețeta dumneavoastră va fi gata în aproximativ {{time}}.",
        "info": "Vă puteți ridica rețeta de la farmacie cu cardul de asigurare sau cu aplicația eRezept.",
        "auto-redirect": "Redirecționare automată în {{seconds}} secunde",
        "back-to-start": "Înapoi la Start",
        "handling-label": "Handled by the practice",
        "next-steps": "Cabinetul vă verifică cererea. După aprobare, puteți ridica rețeta electronică de la farmacie cu cardul de sănătate sau cu aplicația pentru rețete electronice."
      },
      "phase": {
        "identify": "Înregistrare",
        "request": "Cerere",
        "review": "Verificare"
      }
    },
    "check-in": {
      "flow-label": "Înregistrare",
      "has-appointment": {
        "eyebrow": "Numire",
        "title": "Aveți o programare?",
        "subtitle": "Vă rugăm selectați o opțiune",
        "yes-label": "Da",
        "yes": "Da, am o programare",
        "yes-description": "Vreau să fac check-in pentru programarea mea.",
        "yes-hint": "Calea cea mai rapidă",
        "unsure-label": "Poate",
        "unsure": "Nu sunt sigur",
        "unsure-description": "Vom verifica pentru dvs.",
        "unsure-hint": "Vă vom căuta",
        "no-label": "Nr",
        "no": "Nu, fără programare",
        "no-description": "Nu am o programare.",
        "no-hint": "Walk-in"
      },
      "card-check": {
        "eyebrow": "Card de asigurare",
        "title": "Citiți Cardul de Asigurare",
        "subtitle": "Vă rugăm introduceți cardul de asigurare în cititor",
        "insert-title": "Introduceți cardul de asigurare de sănătate în cititor.",
        "insert-detail": "Vă citim detaliile automat — nu trebuie să faceți nimic altceva.",
        "other-ways": "Alte moduri",
        "no-card-hint": "Dacă nu ai cardul la tine chiar acum.",
        "pkv-hint": "Utilizați QR code cu aplicația de asigurare.",
        "loading": "Se încarcă setările...",
        "no-terminal": "Niciun cititor de carduri configurat. Vă rugăm contactați personalul.",
        "checking": "Se verifică cardurile...",
        "insert-prompt": "Vă rugăm introduceți cardul...",
        "card-detected": "Card detectat! Gata de citire.",
        "read-card": "Citește Card",
        "simulate-insert": "Simulează card",
        "reading": "Se citește cardul...",
        "error": "Nu s-a putut citi cardul. Vă rugăm încercați din nou.",
        "read-error": "Citirea datelor de pe card a eșuat. Vă rugăm încercați din nou.",
        "settings-error": "Nu s-au putut încărca setările. Vă rugăm încercați din nou.",
        "no-card-prompt": "Nu aveți cardul?",
        "no-card-action": "Căutare manuală",
        "connection-warning": "Probleme de conectare cu cititorul de carduri. Va rog asteptati...",
        "pkv-prompt": "Asigurare privată? Online Check-in",
        "pkv-instruction": "Scanați acest QR code cu aplicația dvs. privată de asigurări de sănătate pentru a vă transmite datele digital.",
        "pkv-continue": "Continuați cu înregistrarea manuală",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Vă rugăm să încercați din nou sau să vă înregistrați fără card. Recepția vă ajută cu plăcere.",
        "title-pkv": "Înregistrare prin aplicație",
        "title-reading": "Cardul dumneavoastră este citit …",
        "title-unreadable": "Cardul nu a putut fi citit",
        "title-no-terminal": "Înregistrare fără card",
        "no-terminal-body": "Cititorul de carduri nu este disponibil acum. Înregistrați-vă fără card sau adresați-vă recepției.",
        "reading-detail": "Vă rugăm să lăsați cardul în cititor. Durează doar o clipă.",
        "other-ways-title": "Alte posibilități",
        "no-card-title": "Înregistrare fără card",
        "pkv-prompt-title": "Asigurat privat?",
        "pkv-prompt-hint": "Înregistrare prin aplicația asigurării dumneavoastră private de sănătate",
        "pkv-close": "Totuși cu cardul",
        "pkv-instruction-app": "Deschideți aplicația asigurării private de sănătate și scanați acest cod. Datele dumneavoastră ne parvin apoi direct."
      },
      "patient-selection": {
        "title": "Selectați Pacientul",
        "subtitle": "Găsiți mai mulți pacienți. Vă rugăm selectați-vă pe dvs.",
        "firstname-label": "Prenume",
        "firstname-placeholder": "Introduceți prenumele...",
        "confirm-button": "Confirmați",
        "no-match": "Nu a fost găsit niciun pacient potrivit. Vă rugăm să mergeți la recepție pentru asistență.",
        "still-ambiguous": "Rămân mai multe meciuri. Vă rugăm să mergeți la recepție pentru asistență.",
        "select-error": "Nu s-a putut identifica pacientul. Vă rugăm să încercați din nou.",
        "staff-assist": "Mergeți la recepție",
        "title-v2": "O scurtă întrebare",
        "subtitle-v2": "Pentru siguranță, introduceți prenumele.",
        "no-match-v2": "Nu v-am găsit cu acest prenume. Verificați ortografia sau adresați-vă recepției.",
        "still-ambiguous-v2": "Încă nu v-am putut identifica clar. Adresați-vă recepției.",
        "select-error-v2": "Din păcate nu a funcționat. Încercați din nou."
      },
      "card-checkin": {
        "title": "Confirmați Check-in",
        "subtitle": "Datele dvs. au fost citite cu succes.",
        "confirm": "Confirmă check-in"
      },
      "register-from-card": {
        "title": "Înregistrare Nouă",
        "subtitle": "Nu sunteți încă în sistemul nostru. Doriți să vă înregistrați?",
        "card-data": "Date card",
        "create": "Înregistrează-te",
        "create-error": "Înregistrarea a eșuat. Vă rugăm să încercați din nou sau să solicitați asistență personalului.",
        "staff-assist": "Apelați personalul",
        "no-card-data-title": "Fără date de card",
        "no-card-data": "Imposibil de citit datele de pe cardul dvs.",
        "insurance-verified": "Asigurare verificata: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Datele dumneavoastră de pe card",
        "subtitle-v2": "Verificați-vă datele. Dacă ceva nu este corect, atingeți „Modificare”.",
        "create-v2": "Confirmare date",
        "create-error-v2": "Înregistrarea din păcate nu a funcționat. Încercați din nou sau adresați-vă recepției.",
        "insurer-missing-v2": "Pe cardul dumneavoastră lipsește casa de asigurări. Adresați-vă recepției.",
        "edit": "Modificare",
        "name": "Nume",
        "insurer": "Casa de asigurări de sănătate"
      },
      "patient-lookup": {
        "title": "Căutare Pacient",
        "subtitle": "Vă rugăm introduceți numele sau numărul de asigurare.",
        "lastname": "Nume",
        "lastname-placeholder": "Numele dvs. de familie",
        "dob": "Data naşterii",
        "firstname": "Prenume",
        "firstname-placeholder": "Prenume",
        "search": "Căutare",
        "searching": "Se caută...",
        "search-placeholder": "Nume sau număr de asigurare...",
        "results-placeholder": "Rezultatele căutării vor apărea aici",
        "found": "Pacient găsit!",
        "confirm-identity": "Vă rugăm să confirmați că sunteți pacientul prezentat.",
        "confirm-button": "Acela sunt eu",
        "ambiguous-firstname": "Au fost depistaţi mai mulţi pacienţi. Vă rugăm să introduceți prenumele dvs.",
        "ambiguous-additional": "Au fost depistaţi mai mulţi pacienţi. Vă rugăm să contactați personalul.",
        "disambiguation-hint": "Acest lucru ne ajută să vă identificăm în mod clar.",
        "not-found": "Nu a fost găsit niciun pacient cu aceste detalii.",
        "error": "Eroare de căutare: {{message}}",
        "staff-assist": "Apelați personalul",
        "not-found-prompt": "Nu ați găsit?",
        "register-new": "Înregistrează nou",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Înregistrare fără card",
        "subtitle-firstname": "Introduceți și prenumele.",
        "ambiguous-firstname-v2": "Există mai multe persoane cu acest nume. Introduceți și prenumele.",
        "search-again": "Căutare din nou",
        "found-v2": "V-am găsit",
        "found-confirm": "Confirmați cu „Eu sunt”.",
        "not-found-title": "Nu v-am găsit",
        "not-found-check": "Verificați ortografia și data nașterii. Recepția vă ajută cu plăcere.",
        "not-found-reception": "Verificați ortografia și data nașterii sau adresați-vă recepției.",
        "ambiguous-additional-v2": "Nu v-am putut identifica clar. Adresați-vă recepției.",
        "error-v2": "Căutarea nu a funcționat acum. Încercați din nou."
      },
      "checking-in": {
        "title": "Un moment — vă verificăm.",
        "subtitle": "Vă adăugăm la coada de tratament și anunțăm echipa.",
        "step-insurance": "Asigurare verificata",
        "step-appointment": "Numirea confirmată",
        "step-waitlist": "Adăugarea la lista de așteptare",
        "error": "Înregistrarea nu a reușit. Vă rugăm să încercați din nou.",
        "continue": "Continuați oricum",
        "title-v2": "Un moment, vă rog",
        "loading": "Vă înregistrăm …",
        "subtitle-v2": "Vă trecem pe lista de așteptare și anunțăm echipa.",
        "error-title": "Din păcate nu a funcționat",
        "error-v2": "Înregistrarea nu a putut fi finalizată.",
        "error-body": "Încercați din nou. Dacă nici atunci nu merge, vă ajută recepția."
      },
      "appointment-selection": {
        "title": "Selectați întâlnirea",
        "subtitle": "Ai mai multe întâlniri astăzi. Vă rugăm să alegeți unul.",
        "checking-in": "Înregistrare...",
        "time": "{{time}}",
        "error-v2": "Înregistrarea pentru această programare nu a funcționat. Încercați din nou sau adresați-vă recepției."
      },
      "no-appointment": {
        "title": "Nu a fost găsită nicio programare",
        "subtitle": "Nu am putut găsi o întâlnire pentru dvs. astăzi. Vă rugăm să rezervați o întâlnire regulată.",
        "book-appointment": "Fă programare",
        "book-appointment-description": "Rezervați o nouă întâlnire prin programatorul obișnuit.",
        "staff-assist": "Apelați personalul",
        "staff-assist-description": "Am nevoie de ajutor.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Nu am găsit nicio programare pentru dumneavoastră astăzi.",
        "book-v2": "Programare nouă",
        "book-v2-description": "Alegeți acum un interval liber.",
        "have-appointment": "Am o programare",
        "have-appointment-description": "Recepția vă ajută cu plăcere.",
        "unavailable-title": "Programările se fac la recepție",
        "subtitle-unavailable": "Nu am găsit nicio programare pentru dumneavoastră astăzi. Adresați-vă recepției."
      },
      "staff-assist": {
        "title": "Personalul sesizat",
        "subtitle": "Un membru al personalului vă va ajuta în scurt timp.",
        "message": "Vă rugăm să așteptați aici. Un membru al personalului vă va fi alături în curând.",
        "start-over": "Înapoi la început",
        "auto-redirect": "Revenirea la pornire în {{seconds}} secunde..."
      },
      "eeb-prompt": {
        "title": "Verificați Asigurarea",
        "title-failed": "Verificare Eșuată",
        "subtitle": "Cum doriți să vă verificați asigurarea?",
        "subtitle-failed": "Scanați codul QR cu aplicația de asigurare pentru a solicita verificarea.",
        "verify-card": "Verifică electronic",
        "verify-card-description": "Trimiteți o cerere către furnizorul dvs. de asigurări.",
        "select-insurer": "Selectați asigurătorul",
        "select-insurer-description": "Selectare manuală a asigurătorului.",
        "skip": "Omite",
        "eyebrow-chip": "Alternativ",
        "eyebrow": "Înregistrare · dovada asigurării (eEB)",
        "recommended": "Recomandat",
        "qr-title": "Scanați cu aplicația de asigurare",
        "qr-description": "Deschideți aplicația de asigurări de sănătate și scanați codul — eEB ne este trimis direct.",
        "qr-address-label": "Trimite la",
        "title-app": "Dovadă prin aplicație",
        "subtitle-app": "Casa de asigurări ne poate trimite dovada și direct. Când ați terminat, atingeți „Înainte”."
      },
      "quarterly-check": {
        "title": "Verificare Asigurare",
        "checking": "Verificăm verificarea dvs. actuală de asigurare...",
        "error": "Verificarea nu a putut fi efectuată.",
        "title-v2": "Asigurarea dumneavoastră",
        "checking-v2": "Verificăm asigurarea dumneavoastră – un moment, vă rog.",
        "error-body": "Înregistrarea este finalizată. Recepția va clarifica asigurarea împreună cu dumneavoastră."
      },
      "insurer-prefilled": {
        "title": "Asigurarea Dvs. de Sănătate",
        "subtitle": "Vă rugăm confirmați asigurarea pentru acest trimestru.",
        "your-insurance": "Asigurarea dvs.",
        "last-read": "Ultima verificare pe {{date}}",
        "quarterly-notice": "Pentru scopuri de facturare, avem nevoie de o dovadă actuală de asigurare pentru acest trimestru.",
        "confirm-button": "Da, aceasta este asigurarea mea",
        "change-button": "Am o asigurare diferită",
        "contact-title": "Solicitați o dovadă electronică de acoperire",
        "contact-description": "Sunați-vă asigurarea și solicitați o dovadă electronică a acoperirii pentru:",
        "contact-patient": "Pacient",
        "contact-kim-address": "Adresa KIM a cabinetului medical",
        "contact-phone": "Phone",
        "question": "Aceasta este casa dumneavoastră de asigurări?",
        "quarterly-notice-v2": "O dată pe trimestru avem nevoie de o dovadă de la casa de asigurări."
      },
      "insurer-search": {
        "title": "Selectați Asigurarea de Sănătate",
        "subtitle": "Vă rugăm căutați și selectați asigurarea dvs. de sănătate obligatorie.",
        "placeholder": "Căutare asigurare...",
        "hint": "Introduceți cel puțin 2 caractere pentru a căuta.",
        "no-results": "Nicio asigurare găsită.",
        "no-results-hint": "Verificați ortografia sau încercați o căutare diferită.",
        "label": "Numele casei dumneavoastră de asigurări",
        "search-error-v2": "Căutarea nu a funcționat acum. Încercați din nou.",
        "app-alternative": "Preferați aplicația casei de asigurări?"
      },
      "insurer-contact": {
        "title": "Solicitați dovada asigurării",
        "subtitle": "Vă rugăm să alegeți una dintre următoarele opțiuni.",
        "or": "sau",
        "option-eeb-title": "Solicitare electronic",
        "option-eeb-description": "Dacă există cazul de excepție prevăzut de lege, după consimțământul dumneavoastră puteți preda cererea echipei cabinetului.",
        "option-qr-title": "Scanați cu aplicația",
        "option-qr-description": "Scanați QR code cu aplicația de asigurare.",
        "option-call-title": "Sună-te",
        "option-call-description": "Sunați la asigurarea dumneavoastră și solicitați un eEB pentru acest cabinet medical:",
        "phone": "Phone",
        "phone-not-available": "Număr de telefon de pe cardul de asigurare",
        "patient-name": "Pacient",
        "practice-kim": "Adresa KIM a cabinetului medical",
        "help-notice": "Dacă aveți probleme, vă rugăm să vizitați biroul de recepție.",
        "submit-eeb-button": "Solicitați acum",
        "contacted-button": "Am sunat",
        "contacted-button-countdown": "Ora pentru apelul dvs. ({{seconds}}s)",
        "go-to-counter-button": "Mergeți la recepție",
        "qr-continue-button": "Am scanat",
        "qr-continue-button-countdown": "Timpul pentru scanare ({{seconds}}s)",
        "title-v2": "Dovada de la casa dumneavoastră de asigurări",
        "subtitle-v2": "Cel mai simplu este prin aplicația casei de asigurări.",
        "subtitle-no-app": "Alegeți cum să ne trimită casa de asigurări dovada.",
        "option-eeb-description-v2": "Cerem noi dovada de la casa de asigurări în locul dumneavoastră. Pentru aceasta avem nevoie de acordul dumneavoastră.",
        "call-instruction": "Sunați la casa de asigurări și cereți să trimită dovada cabinetului nostru.",
        "call-instruction-practice": "Sunați la casa de asigurări și cereți să trimită dovada cabinetului {{practice}}.",
        "done-button": "Gata – înainte",
        "done-button-countdown": "Gata – înainte (încă {{seconds}} s)"
      },
      "eeb-consent": {
        "title": "Consimțământ",
        "subtitle": "Avem nevoie de consimțământul dvs. pentru verificarea electronică a asigurării.",
        "insurance": "Asigurarea dvs.",
        "consent-title": "Consimțământ pentru Verificarea Electronică a Asigurării (eEB)",
        "consent-text": "Înțeleg că asigurarea mea de sănătate va transmite datele mele de asigurare (de ex., nume, data nașterii, numărul de asigurare) prin serviciul securizat de comunicare KIM către cabinetul medical {{practiceName}} ca dovadă a asigurării. Sunt de acord cu această transmitere. Știu că pot revoca acest consimțământ oricând fără a-mi afecta tratamentul.",
        "withdrawal-notice": "Puteți revoca acest consimțământ oricând.",
        "agree-button": "Sunt de acord",
        "decline-button": "Anulare",
        "treatment-notice": "Tratamentul dvs. nu este afectat de acest consimțământ.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Dovada de la casa dumneavoastră de asigurări",
        "summary": "Casa de asigurări ne trimite dovada direct. Pentru aceasta avem nevoie de acordul dumneavoastră.",
        "confirm-first": "Vă rugăm să confirmați mai întâi declarația."
      },
      "qr-code": {
        "title": "Scanați cu aplicația de asigurare",
        "instruction-1": "Deschideți aplicația de asigurare și scanați acest cod QR.",
        "instruction-2": "Cabinetul medical va primi apoi automat verificarea asigurării dumneavoastră.",
        "practice": "Cabinet medical: {{name}}",
        "alternative-hint": "Alternativ: Folosiți aplicația de asigurare",
        "instruction-app": "Deschideți aplicația casei dumneavoastră de asigurări de sănătate și scanați acest cod. Dovada ne parvine apoi direct.",
        "staff-line": "Pentru echipa cabinetului: {{address}}",
        "staff-line-practice": "Pentru echipa cabinetului: {{name}} · {{address}}",
        "alternative-app": "Puteți cere dovada și prin aplicația casei de asigurări: deschideți aplicația și scanați acest cod."
      },
      "register-basics": {
        "title": "Informații Personale",
        "subtitle": "Vă rugăm introduceți datele dvs.",
        "family-name": "Nume",
        "given-name": "Prenume",
        "dob": "Data nașterii",
        "gender": "Gen",
        "insurance-type": "Tip asigurare",
        "insurer-name": "Numele asigurării dumneavoastră",
        "insurer-name-placeholder": "de ex. Debeka, DKV, Allianz...",
        "gender-required": "Alegeți o opțiune."
      },
      "register-insurer": {
        "title": "Asigurare de Sănătate",
        "subtitle": "Vă rugăm selectați asigurarea dvs. de sănătate.",
        "search-placeholder": "Căutare asigurare..."
      },
      "register-details": {
        "title": "Rezumat",
        "subtitle": "Vă rugăm verificați informațiile dvs.",
        "create": "Finalizează înregistrarea",
        "missing-data": "Vă rugăm să completați toate câmpurile obligatorii.",
        "create-error": "Înregistrarea a eșuat. Vă rugăm să încercați din nou.",
        "policy-number": "Numărul poliței (opțional)",
        "policy-number-placeholder": "Numărul poliței dvs",
        "create-v2": "Finalizare înregistrare",
        "policy-number-hint": "Numărul îl găsiți pe cardul asigurării."
      },
      "diff-review": {
        "eyebrow-chip": "Revizuire",
        "eyebrow": "Înregistrare · date card",
        "title": "Comparare Date",
        "subtitle": "Au fost găsite diferențe între datele de pe card și înregistrările noastre.",
        "col-current": "Înregistrare curentă",
        "col-new": "Nou de la card",
        "new-badge": "nou",
        "field-fallback": "Câmp",
        "note": "Datele actualizate ne ajută să facturăm corect și să vă contactam în caz de urgență.",
        "comparison-placeholder": "Comparația va fi afișată aici",
        "confirm": "Confirmă modificările",
        "apply-error": "Datele nu au putut fi aplicate. Vă rugăm să încercați din nou.",
        "retry": "Încercați din nou",
        "skip": "Continuați oricum",
        "no-changes": "Nicio modificare găsită",
        "title-v2": "Datele dumneavoastră s-au schimbat",
        "subtitle-v2": "Pe card sunt date mai noi. Le preluăm?",
        "confirm-v2": "Preluare și înregistrare",
        "keep": "Înregistrare fără modificări",
        "col-current-v2": "Până acum",
        "col-new-v2": "Nou de pe card",
        "value-yes": "Da",
        "value-no": "Nu"
      },
      "insurance-selection": {
        "title": "Tip Asigurare",
        "subtitle": "Vă rugăm selectați tipul de asigurare.",
        "gkv": "Asigurat legal",
        "gkv-description": "Membru al unei asigurări de sănătate obligatorii.",
        "pkv": "Privat sau autofinanțare",
        "pkv-description": "Asigurat privat sau autofinanțare.",
        "pkv-description-v2": "Asigurare privată de sănătate sau plătiți singur."
      },
      "eeb-request": {
        "title": "Cerere înregistrată",
        "subtitle": "Vă puteți finaliza înregistrarea. Răspunsul de la {{insurer}} va ajunge mai târziu la cabinet.",
        "verifying": "Cererea dumneavoastră a fost acceptată pentru procesare imediată.",
        "success": "Cererea dumneavoastră a fost predată în siguranță echipei cabinetului.",
        "error": "Confirmarea cererii nu este disponibilă.",
        "try-alternative": "Metodă alternativă",
        "kim-load-error": "Adresa KIM a cabinetului medical nu a putut fi încărcată.",
        "kim-label": "Cabinet medical · KIM",
        "non-blocking-note": "Acest lucru nu confirmă încă primirea de către casa dumneavoastră de asigurări de sănătate sau statutul dumneavoastră de asigurare.",
        "auto-continue": "Continuare automată în {{seconds}} secunde.",
        "unavailable-title": "Din păcate nu a funcționat",
        "unavailable-v2": "Cererea dumneavoastră către casa de asigurări nu a putut fi înregistrată.",
        "unavailable-body": "Puteți cere dovada prin aplicația casei de asigurări sau puteți rezolva la recepție.",
        "use-app": "Prin aplicație",
        "at-reception": "Rezolvare la recepție"
      },
      "self-pay": {
        "title": "Autofinanțare",
        "subtitle": "Veți fi tratat ca pacient cu autofinanțare.",
        "info": "Vă rugăm rețineți că veți fi responsabil pentru costurile tratamentului.",
        "confirm": "Am înțeles",
        "title-v2": "Plătiți singur",
        "subtitle-v2": "Plătiți singur tratamentul.",
        "insured-after-all": "Totuși sunt asigurat"
      },
      "done": {
        "title": "Gata!",
        "subtitle": "Check-in-ul dvs. este complet.",
        "finish": "Finalizează",
        "done-label": "Efectuat",
        "error-label": "Notificare",
        "eyebrow": "Înregistrarea · finalizată",
        "queue-label": "Sala de asteptare",
        "queue-title": "Vă rugăm să luați loc",
        "queue-meta": "Vă vom suna personal.",
        "success-title": "Check-in reușit!",
        "success-subtitle": "Vă rugăm luați loc în sala de așteptare. Veți fi chemat.",
        "auto-redirect": "Veți fi redirecționat către pagina de start în curând...",
        "auto-redirect-countdown": "Revenirea la pornire în {{seconds}} secunde...",
        "card-expired-title": "Card expirat",
        "card-expired-subtitle": "Cardul dvs. de asigurare a expirat.",
        "card-expired-info": "Vă rugăm contactați personalul pentru asistență.",
        "back-to-start": "Înapoi la start",
        "anamnesis-title": "Formular de istoric medical complet",
        "anamnesis-description": "Scanați QR code pentru a completa formularul de istoric medical în mod convenabil pe smartphone.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "Sunteți înregistrat",
        "card-expired-info-v2": "Adresați-vă recepției."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Verificați-vă datele",
          "balance-prefix": "La salvare:",
          "balance-direct-v2": "Salvat imediat: {{count}}",
          "balance-reception-v2": "Verifică recepția: {{count}}",
          "chip-reception-v2": "Modificările sunt verificate de recepția noastră",
          "chip-changed": "Modificat: {{count}}",
          "remove": "Eliminare",
          "example-email": "ex. nume@exemplu.ro",
          "example-phone": "ex. 0712 345 678",
          "intro-v2": "Înregistrarea este finalizată. Mai sunt corecte aceste date? Verificarea este opțională.",
          "auto-hide": "Valorile afișate sunt ascunse din nou după scurt timp."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Am transmis această informație recepției.",
          "banner-done-v2": "Mulțumim! Am primit datele dumneavoastră.",
          "footer-v2": "Toate celelalte date rămân neschimbate."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "Din motive de protecția datelor am închis afișarea. Înregistrarea este totuși finalizată. Modificările le puteți comunica oricând la recepție."
        }
      },
      "progress": {
        "identify": "Înregistrare",
        "insurance": "Asigurare",
        "done": "Gata"
      },
      "dob-format-hint": "De exemplu 01.10.1980",
      "dob-required": "Introduceți data nașterii.",
      "insurance-label": {
        "GKV": "Asigurare publică",
        "PKV": "Asigurare privată",
        "SELFPAY": "Plată proprie"
      }
    },
    "emergency": {
      "title": "Urgență acută!",
      "label": "Urgență",
      "subtitle": "Această alertă se aude doar local și nu a chemat ajutor. Pentru urgențe acute sau care pot pune viața în pericol, sunați la 112.",
      "call-emergency": "Apelați la serviciile de urgență (112)",
      "stop-sound": "Opriți sunetul",
      "play-sound": "Redați sunet",
      "back-to-start": "Înapoi la început",
      "headline": "Adresați-vă imediat personalului de la recepție. În caz de pericol de moarte, sunați la 112."
    },
    "help-reception": "Ajutor la receptie",
    "help-reception-toast": "Vă rugăm să contactați recepția. Suntem bucuroși să vă ajutăm.",
    "language-entry": {
      "title": "Alegeți limba"
    },
    "loading": "Se încarcă…",
    "step-progress-label": "Progres",
    "step-progress-phase": "Secțiunea {{current}} din {{total}}: {{phase}}",
    "step-progress-substep": "Partea {{current}} din {{total}}",
    "step-progress-complete": "Finalizat",
    "identification": {
      "title": "Cine sunteți?",
      "lead": "Cel mai rapid este cu cardul de sănătate. Puteți căuta și după nume.",
      "lead-card-only": "Vă rugăm să introduceți cardul de sănătate în cititorul de carduri.",
      "mode-label": "Cum doriți să vă înregistrați?",
      "mode-card": "Cu cardul",
      "mode-search": "Căutare după nume",
      "mode-create": "Pacient nou",
      "card": {
        "loading": "Se pregătește cititorul de carduri …",
        "checking": "Se verifică cititorul de carduri …",
        "insert-title": "Vă rugăm să introduceți cardul de sănătate în cititorul de carduri.",
        "insert-detail": "Citim datele dvs. automat.",
        "detected": "Card recunoscut",
        "read": "Citește cardul",
        "reading": "Se citește cardul …",
        "reading-hint": "Vă rugăm să lăsați cardul introdus.",
        "no-terminal-title": "Cititorul de carduri nu este disponibil",
        "help-with-search": "Vă rugăm să căutați după nume sau să întrebați la recepție.",
        "help-reception": "Vă rugăm să întrebați la recepție – vă ajutăm cu plăcere.",
        "unreadable-title": "Card recunoscut, dar nu poate fi citit",
        "error-title": "Cardul nu a putut fi citit",
        "not-unique": "Nu v-am putut asocia clar cu acest card. Vă rugăm să căutați după nume sau să întrebați la recepție.",
        "no-match": "Nu am găsit date pentru acest card. Vă rugăm să căutați după nume sau să întrebați la recepție.",
        "without-card": "Continuați fără card"
      },
      "lookup": {
        "lead": "Vă rugăm să introduceți numele de familie și data nașterii.",
        "first-name": "Prenume",
        "last-name": "Nume de familie",
        "dob": "Data nașterii",
        "dob-hint": "Format: ZZ.LL.AAAA",
        "search": "Căutare",
        "confirm": "Da, eu sunt",
        "found-title": "V-am găsit",
        "found-body": "Vă rugăm să confirmați că este vorba despre dvs.",
        "first-name-needed-title": "Vă rugăm să adăugați prenumele",
        "first-name-needed-body": "Ca să vă găsim clar. Apoi atingeți „Căutare”.",
        "ambiguous-title": "Nu v-am putut găsi clar",
        "ambiguous-body": "Vă rugăm să întrebați la recepție – vă ajutăm cu plăcere.",
        "not-found-title": "Nu s-au găsit date potrivite",
        "not-found-body": "Vă rugăm să verificați datele introduse.",
        "error-title": "Căutarea nu este posibilă acum",
        "error-body": "Vă rugăm să încercați din nou sau să întrebați la recepție."
      },
      "create": {
        "insurance-question": "Cum sunteți asigurat?",
        "insurance-required": "Vă rugăm să alegeți cum sunteți asigurat.",
        "error-title": "Datele dvs. nu au putut fi salvate",
        "error-body": "Vă rugăm să încercați din nou sau să întrebați la recepție."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Deblocați mai întâi",
      "subtitle": "FrontDesk+ trebuie să fie activat în software-ul dvs. de practică.",
      "step1": "Comandați în SolStore (sau partenerul dvs. Doc-Cirrus comandă pentru dvs.).",
      "step2": "După activare, activați în inSuite sub „inSuite Sols” (drepturi de administrator).",
      "step3": "Deschideți administrarea Bridge → „Adăugați dispozitiv”.",
      "cta": "Gata totul - merge mai departe"
    },
    "welcome": {
      "title": "Adăugați acest dispozitiv la practică",
      "scan": "Faceți o fotografie a codului",
      "prepare-link": "Niciun cod în inSuite?",
      "language": "Limbă"
    },
    "scan": {
      "requesting": "Se solicită accesul la cameră...",
      "scanning": "Îndreptați camera către cod",
      "paste": "Lipiți în schimb",
      "manual-title": "Conectați manual",
      "manual-description": "Dacă codul QR nu este disponibil, luați datele de conectare de la administrația Bridge.",
      "address-label": "Adresa Bridge",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Introduceți SOLTOKEN",
      "manual-submit": "Preia conexiunea",
      "error-title": "Codul nu este recunoscut",
      "camera-denied-title": "Accesul la cameră a fost interzis",
      "camera-denied-hint": "Permiteți accesul la cameră în setări și încercați din nou.",
      "retry": "Încearcă din nou"
    },
    "preflight": {
      "title": "Va fi înființat",
      "all-green": "Toate testele au trecut",
      "practice": "Practica",
      "device-name": "Numele dispozitivului",
      "device-name-placeholder": "de ex. B. Recepție 1",
      "card-reader": "Cititor de carduri",
      "pin": "Număr secret nou",
      "pin-placeholder": "PIN din patru cifre",
      "finish": "Termina",
      "recheck": "Verificați din nou",
      "diagnosis": "ID diagnostic",
      "checklist-error": "Bridge-ul a refuzat conexiunea sau nu poate fi accesat. Verificați SOLTOKEN și adresa Bridge.",
      "checklist-retry": "Verificați din nou",
      "edit-token": "Modificați SOLTOKEN",
      "rescan": "Scanați din nou codul"
    },
    "persisting": "Se salvează configurarea …",
    "success": {
      "title": "Dispozitiv adăugat",
      "detail": "Dispozitivul tocmai a apărut pe PC-ul de antrenament.",
      "starting": "Modul pacient începe..."
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Conexiune la software-ul de practică",
        "fix": "Bridge Verificați conexiunea și adresa serverului."
      },
      "missing_insuite_url": {
        "label": "Adresa inSuite",
        "fix": "Scanați din nou codul QR - adresa lipsește."
      },
      "missing_server_token": {
        "label": "Jeton de server",
        "fix": "Scanați din nou codul QR - simbolul lipsește."
      },
      "missing_gateway_session": {
        "label": "Sesiune Gateway",
        "fix": "Conectați-vă din nou — sesiunea lipsește."
      },
      "missing_gateway_enrollment": {
        "label": "Înregistrarea dispozitivului",
        "fix": "Înregistrați dispozitivul pe Gateway."
      },
      "gateway_not_ready": {
        "label": "Gateway pregătire",
        "fix": "Așteptați ca Gateway să finalizeze configurarea."
      },
      "token_verification_failed": {
        "label": "Verificare jetoane",
        "fix": "Verificați jetonul serverului sau conexiunea Bridge."
      },
      "session_expired": {
        "label": "întâlnire",
        "fix": "Sesiunea a expirat - conectați-vă din nou."
      },
      "device_revoked": {
        "label": "Starea dispozitivului",
        "fix": "Acest dispozitiv a fost blocat. Contactați practica."
      },
      "missing_practice_name": {
        "label": "Nume de practică",
        "fix": "Numele cabinetului medical nu a putut fi încărcat (inSuite)."
      },
      "missing_device_name": {
        "label": "Numele dispozitivului",
        "fix": "Introduceți un nume de dispozitiv."
      },
      "telematik_unavailable": {
        "label": "Infrastructura telematică",
        "fix": "Opțional — verificarea cardului rămâne posibilă de îndată ce TI este disponibil."
      },
      "selected_card_reader_unavailable": {
        "label": "Cititor de carduri",
        "fix": "Opțional — selectați sau conectați un cititor de carduri."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Opțional — introduceți cardul de acreditare a cabinetului medical (SMC-B)."
      }
    },
    "token": {
      "title": "Introduceți SOLTOKEN",
      "description": "Din motive de securitate, codul QR nu conține SOLTOKEN. Copiați-l în inSuite la „Sol-Aktivierung” (FrontDesk+) și lipiți-l aici.",
      "submit": "Continuați",
      "rescan": "Scanați din nou codul"
    }
  }
}
